module.exports = __webpack_public_path__ + "static/img/img_m.264a3b4d.png";